module.exports = __webpack_public_path__ + "static/img/Liquid Silicone Rubber for Baby Care.7660e14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Liquid Silicone Rubber for Baby Care.jpg
// module id = QP4O
// module chunks = 1